import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import download from 'downloadjs';
import {
  addToast,
  Button,
  IconButton,
  FileInput,
  Text,
  useTooltipWithLiveRegion
} from '@albert-io/atomic';

import './upload-csv-btn.scss';

export default class UploadCSVBtn extends React.PureComponent {
  static propTypes = {
    csvHeaderValues: PropTypes.arrayOf(PropTypes.string),
    onUpload: PropTypes.func
  };

  static defaultProps = {
    csvHeaderValues: [],
    onUpload: () => {}
  };

  CSVUploadInputRef = React.createRef();

  popoverTargetRef = React.createRef();

  handleUpload = (e) => {
    const {files} = e.target;
    if (files.length === 0) {
      return;
    }

    const file = files[0];

    const reader = new FileReader();
    reader.onload = (evt) => {
      const fileContent = evt.target.result;
      this.parseItemsFromFile(fileContent);
    };
    reader.readAsText(file, 'UTF-8');
  };

  parseItemsFromFile(fileContent) {
    // Formats columns and rows, trims whitespace, and removes empty cells
    const parsedItems = fileContent
      .replace(/[\n\r]+/g, ',')
      .replace(/\s+/g, '')
      .split(',')
      .filter((item) => item && !this.props.csvHeaderValues.includes(item));

    addToast({
      message: `Successfully imported ${parsedItems.length} items.`,
      title: 'Success!',
      type: 'success'
    });

    this.props.onUpload(parsedItems.join(';\n'));
  }

  render() {
    return (
      <>
        <FileInput
          accept='text/csv'
          icon='table'
          placeholder='Upload CSV'
          onChange={this.handleUpload}
        />
        <CSVTemplateTooltip />
      </>
    );
  }
}

const CSVTemplateTooltip = () => {
  const csvHeaderValues = ['Email'];
  const tooltipAnchorRef = useRef(null);

  const {
    closeTooltip,
    handleEscape,
    openTooltip,
    tooltipContentRef,
    tooltipProps,
    TooltipWithLiveRegion
  } = useTooltipWithLiveRegion(tooltipAnchorRef);

  const handleClick = () => {
    download(csvHeaderValues.join(','), 'ImportTemplate.csv', 'text/csv');
  };

  return (
    <span className='u-align-self_center upload-csv-btn__tooltip-wrapper'>
      <IconButton
        icon={['far', 'question-circle']}
        label='More info'
        size='s'
        onBlur={closeTooltip}
        onClick={openTooltip}
        onKeyDown={handleEscape}
        ref={tooltipAnchorRef}
      />
      <TooltipWithLiveRegion
        {...tooltipProps}
        className='u-display_flex u-flex-direction_column upload-csv-btn__tooltip'
        placement='top'
        theme='light'
      >
        <Text as='p' className='u-display_block u-mar-b_2'>
          Uploading a CSV allows you to easily invite multiple students to your classroom with just
          one file.
        </Text>
        <Text as='p' className='u-display_block u-mar-b_2'>
          Use our template to get started.
        </Text>
        <Button className='u-width_100pc' onClick={handleClick} ref={tooltipContentRef}>
          Download CSV template
        </Button>
      </TooltipWithLiveRegion>
    </span>
  );
};
